<template>
  <span class="tr-static-text">
    <tr-text :text="item.value" :type="item.katex" v-for="(item, index) in parseText" :key="index"> </tr-text>
  </span>
</template>

<script>
import _ from 'lodash';
import TrText from '../TrInput/TrText';
export default {
  name: 'tr-static-text',
  components: { TrText },
  props: {
    staticText: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  methods: {
    /** Function added only for compatibility with hack in textBlock type components */
    removeUnnecessarySlash(string) {
      const search = '\\\\';
      const replaceWith = '\\';
      const result = string.split(search).join(replaceWith);
      return result;
    },
    parseKatex(string) {
      let parsed = [];
      let split = string.split(/(_#.*?#_)/g);
      if (split) {
        // for (const item of split) {
        parsed = split.map((item) => {
          let katexFlag = false;
          let match = item.match(/_#(.*?)#_/g);
          if (match) {
            katexFlag = true;
            item = item.substring(2, item.length - 2);
            item = this.removeUnnecessarySlash(item);
          }
          return { katex: katexFlag, value: item };
        });
        // }
      }
      return parsed;
    },
  },
  computed: {
    parseText() {
      return this.parseKatex(this.staticText.text);
    },
  },
};
</script>

<style lang="scss" scoped></style>
